<template>
  <div class="model-category-container">
    <div class="model-category-content">
      <div class="model-category-header">
        <h2>模型分类管理</h2>
        <p>管理模型分类，方便模型归类</p>
      </div>
      
      <div class="add-category">
        <el-input
          v-model="newCategory.name"
          placeholder="分类名称"
          style="width: 300px; margin-right: 10px"
        ></el-input>
        <el-button type="primary" @click="addCategory">添加分类</el-button>
      </div>
      
      <div class="category-list">
        <el-table :data="categories" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="name" label="分类名称"></el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="editCategory(scope.row)">编辑</el-button>
              <el-button size="small" type="danger" @click="deleteCategory(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <!-- 编辑分类对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="80px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ModelCategory',
  data() {
    return {
      newCategory: {
        name: ''
      },
      categories: [
        {
          id: 1,
          name: '图片模型',
          created_at: '2025-04-01 10:00:00'
        },
        {
          id: 2,
          name: '视频模型',
          created_at: '2025-04-01 10:00:00'
        },
        {
          id: 3,
          name: '短剧模型',
          created_at: '2025-04-01 10:00:00'
        },
        {
          id: 4,
          name: '文案模型',
          created_at: '2025-04-01 10:00:00'
        }
      ],
      dialogVisible: false,
      dialogTitle: '',
      editForm: {
        id: '',
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    addCategory() {
      if (!this.newCategory.name) {
        this.$message.error('请输入分类名称')
        return
      }
      
      const newId = this.categories.length + 1
      const now = new Date().toLocaleString()
      
      this.categories.push({
        id: newId,
        name: this.newCategory.name,
        created_at: now
      })
      
      this.newCategory.name = ''
      this.$message.success('分类添加成功')
    },
    editCategory(category) {
      this.dialogTitle = '编辑分类'
      this.editForm = {
        id: category.id,
        name: category.name
      }
      this.dialogVisible = true
    },
    saveEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const index = this.categories.findIndex(item => item.id === this.editForm.id)
          if (index !== -1) {
            this.categories[index].name = this.editForm.name
            this.dialogVisible = false
            this.$message.success('分类编辑成功')
          }
        }
      })
    },
    deleteCategory(id) {
      this.$confirm('确定要删除这个分类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.categories = this.categories.filter(item => item.id !== id)
        this.$message.success('分类删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style scoped>
.model-category-container {
  padding: 20px 0;
}

.model-category-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.model-category-header {
  margin-bottom: 30px;
}

.model-category-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.model-category-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.add-category {
  margin-bottom: 30px;
}

.category-list {
  margin-top: 20px;
}
</style>
